var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFriendIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 20c0 11-9 23-19 23S20 31 20 20 29 0 39 0s19 9 19 20ZM58 67l-8 8c-22 0-50 4-50-9 0-12 17-21 39-21 9 0 11 1 18 3 6 1 13 8 8 11l-7 8Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 72.3,
    width: 34,
    height: 12.4,
    rx: 4,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 60.9,
    width: 35.1,
    height: 12,
    rx: 4,
    transform: "rotate(90 78 61)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFriendIconDark);
export default __webpack_public_path__ + "static/media/add_friend_icon_dark.daa35f99c12e3f0670fb776acd2f0954.svg";
export { ForwardRef as ReactComponent };